import {Component, DoCheck, EventEmitter, Input, Output} from '@angular/core';
import {InputMessages} from "./input-messages";
import {ErrorMessage} from "./error-message";
import {FormGroup, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: 'sara-input-a2',
    templateUrl: './sara-input-a2.component.html',
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: SaraInputA2Component, multi: true}
    ],
})
export class SaraInputA2Component {

    @Input() messages:InputMessages;
    @Input() error:ErrorMessage;
    @Input() name:string;
    @Input() maxlength:number;
    @Input() minlength:number;
    @Input() required:boolean;

    @Output() modelChange: EventEmitter<string> = new EventEmitter();

    modelValue = "";

    @Input()
    get model() {
        return this.modelValue;
    }

    set model(val) {
        this.updateValidation();
        this.modelValue = val;
        this.modelChange.emit(this.modelValue);
    }

    updateValidation = function () {
        if(this.error){
            this.error = null;
        }
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/sara-input/sara-input-a2.component.ts